<template>
  <div class="content">
    <div class="md-layout">
      <md-card class="md-card-plain">
        <md-card-header data-background-color="blue">
          <h4 class="title">Listado de Usuarios</h4>
          <p class="category">Gestione, edite y elimine usuarios</p>
        </md-card-header>
        <md-card-content>
          <div class="table-container">
            <table class="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombres</th>
                  <th>Apellidos</th>
                  <th>Correo</th>
                  <th>Cédula</th>
                  <th>Rol</th>
                  <th>Regional</th>
                  <th>Estado</th> <!-- Nueva columna para el estado -->
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="usuario in usuarios" :key="usuario.id">
                  <td>{{ usuario.id }}</td>
                  <td>{{ usuario.nombre }}</td>
                  <td>{{ usuario.apellidos }}</td>
                  <td>{{ usuario.correo }}</td>
                  <td>{{ usuario.cedula }}</td>
                  <td>{{ usuario.rol }}</td>
                  <td>{{ usuario.regional }}</td> <!-- Usamos regional_nombre del JOIN -->
                  <td>
                    <span
                      :class="{ 'status-online': isOnline(usuario.ultima_conexion), 'status-offline': !isOnline(usuario.ultima_conexion) }">
                      {{ getStatus(usuario.ultima_conexion) }}
                    </span>
                  </td>
                  <td>
                    <button class="action-btn" @click="abrirEditar(usuario)">Editar</button>
                    <button class="action-btn delete" @click="eliminarUsuario(usuario.id)">Eliminar</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </md-card-content>
      </md-card>

    </div>
    <!-- Primer modal (parece duplicado, considera si necesitas ambos) -->
    <div v-if="showEditModal" class="modal-overlay">
      <div class="modal">
        <h3>Editar Usuario</h3>
        <form @submit.prevent="actualizarUsuario">
          <div class="form-group">
            <label>Nombres</label>
            <input type="text" v-model="editingUser.nombre" required />
          </div>
          <div class="form-group">
            <label>Apellidos</label>
            <input type="text" v-model="editingUser.apellidos" required />
          </div>
          <div class="form-group">
            <label>Correo</label>
            <input type="email" v-model="editingUser.correo" required />
          </div>
          <div class="form-group">
            <label>Contraseña (dejar en blanco para no cambiar)</label>
            <input type="password" v-model="editingUser.password" />
          </div>
          <div class="form-group">
            <label>Cédula</label>
            <input type="text" v-model="editingUser.cedula" required />
          </div>
          <div class="form-group">
            <label>Rol</label>
            <select v-model="editingUser.rol" required>
              <option value="admin">Administrador</option>
              <option value="usuario">Usuario</option>
            </select>
          </div>
          <div class="form-group">
            <label>Regional</label>
            <select v-model="editingUser.regional_id" required>
              <option value="" disabled>Seleccione Regional</option>
              <option v-for="reg in regionales" :key="reg.id" :value="reg.id">
                {{ reg.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-actions">
            <button type="submit" class="action-btn">Guardar</button>
            <button type="button" class="action-btn cancel" @click="cerrarModal">Cancelar</button>
          </div>
        </form>
      </div>
    </div>
    <!-- Segundo modal (duplicado, se muestra solo uno a la vez por showEditModal) -->
    <!-- Considera eliminar uno de los dos bloques de modal si son idénticos -->
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import moment from 'moment'; // Importa moment.js para formateo de fechas

export default {
  name: "UserAdmin",
  data() {
    return {
      usuarios: [],
      regionales: [],
      showEditModal: false,
      editingUser: {
        id: null,
        nombre: "",
        apellidos: "",
        correo: "",
        password: "",
        cedula: "",
        rol: "usuario",
        regional_id: null,
        // No necesitamos ultima_conexion aquí para la edición, ya que se actualiza automáticamente
      },
      // Intervalo para refrescar la lista de usuarios y el estado en línea
      refreshInterval: null,
    };
  },
  mounted() {
    this.listarUsuarios();
    this.cargarRegionales();
    // Inicia el refresco automático de la lista cada 30 segundos
    this.startAutoRefresh();
  },
  beforeUnmount() { // O beforeDestroy si usas Vue 2
    // Limpia el intervalo cuando el componente se destruye
    this.stopAutoRefresh();
  },
  methods: {
    async listarUsuarios() {
      try {
        // Asegúrate de que esta URL sea la correcta y que el backend devuelva ultima_conexion
        const response = await this.$axios.get(
          "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/user/consultar_usuarios.php"
        );
        this.usuarios = response.data;
      } catch (error) {
        console.error("Error al listar usuarios:", error); // eslint-disable-line no-console
      }
    },
    async cargarRegionales() {
      try {
        const response = await this.$axios.get(
          "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/regional/listar_regionales.php"
        );
        this.regionales = response.data;
      } catch (error) {
        console.error("Error al cargar regionales:", error);// eslint-disable-line no-console 
      }
    },
    abrirEditar(usuario) {
      // Clonar el usuario seleccionado para editar
      this.editingUser = { ...usuario, password: "" };
      this.showEditModal = true;
    },
    cerrarModal() {
      this.showEditModal = false;
    },
    async actualizarUsuario() {
      try {
        const response = await this.$axios.post(
          "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/user/actualizar_usuario.php",
          this.editingUser
        );

        Swal.fire({
          icon: "success",
          title: "Usuario actualizado",
          text: response.data.message || "El usuario se actualizó correctamente.",
          timer: 2000,
          showConfirmButton: false
        });

        this.cerrarModal();
        this.listarUsuarios(); // Refresca la lista para ver los cambios
      } catch (error) {
        this.mostrarError("Error al actualizar usuario.");
        console.error("Error al actualizar usuario:", error); // eslint-disable-line no-console
      }
    },
    async eliminarUsuario(id) {
      const confirm = await Swal.fire({
        title: "¿Estás seguro?",
        text: "Esta acción eliminará el usuario.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
      });

      if (confirm.isConfirmed) {
        try {
          const response = await this.$axios.post(
            "https://alexpruebas.tamep.bo/kqlurhnh_conciliacion/user/eliminar_usuario.php",
            { id }
          );

          Swal.fire({
            icon: "success",
            title: "Usuario eliminado",
            text: response.data.message || "El usuario ha sido eliminado.",
            timer: 2000,
            showConfirmButton: false
          });

          this.listarUsuarios(); // Refresca la lista
        } catch (error) {
          this.mostrarError("Error al eliminar usuario.");
          console.error("Error al eliminar usuario:", error); // eslint-disable-line no-console
        }
      }
    },
    mostrarError(mensaje) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: mensaje
      });
    },
    /**
     * Determina si un usuario está en línea.
     * Un usuario se considera en línea si su última conexión fue hace menos de 2 minutos.
     * @param {string} ultimaConexionString - La cadena de fecha/hora de ultima_conexion.
     * @returns {boolean} - True si está en línea, False de lo contrario.
     */
    isOnline(ultimaConexionString) {
      if (!ultimaConexionString) {
        return false; // Si no hay registro de conexión, no está en línea
      }
      const lastConnection = moment(ultimaConexionString);
      const now = moment();
      // Define el umbral de "en línea" (ej. 2 minutos)
      const onlineThresholdMinutes = 2;
      return now.diff(lastConnection, 'minutes') < onlineThresholdMinutes;
    },
    /**
     * Retorna el estado del usuario (En línea o Última conexión).
     * @param {string} ultimaConexionString - La cadena de fecha/hora de ultima_conexion.
     * @returns {string} - El estado formateado.
     */
    getStatus(ultimaConexionString) {
      if (this.isOnline(ultimaConexionString)) {
        return 'En línea';
      } else if (ultimaConexionString) {
        // Formatea la fecha para mostrarla de forma amigable
        return `Última conexión: ${moment(ultimaConexionString).format('DD/MM/YYYY HH:mm')}`;
      } else {
        return 'Nunca conectado';
      }
    },
    /**
     * Inicia un intervalo para refrescar la lista de usuarios periódicamente.
     */
    startAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
      }
      // Refresca la lista cada 30 segundos para actualizar el estado en línea
      this.refreshInterval = setInterval(this.listarUsuarios, 30000);
    },
    /**
     * Detiene el intervalo de refresco automático.
     */
    stopAutoRefresh() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
    }
  },
};
</script>

<style scoped>
/* Tus estilos existentes */
.table-container {
  overflow-x: auto;
  width: 100%;
  margin-top: 20px;
}

/* Estilos para la tabla */
.table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
  white-space: nowrap;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

/* Botones de acción */
.action-btn {
  margin-right: 5px;
  padding: 5px 10px;
  border: none;
  background-color: #3f51b5;
  color: #fff;
  cursor: pointer;
  border-radius: 4px;
}

.action-btn.delete {
  background-color: #e53935;
}

.action-btn:hover {
  opacity: 0.9;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  /* Limita la altura del modal */
  overflow-y: auto;
}

.modal h3 {
  margin-top: 0;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.modal-actions {
  text-align: right;
}

.modal-actions .action-btn {
  margin-left: 5px;
}

.modal-actions .cancel {
  background-color: #9e9e9e;
}

/* Estilos para el estado en línea/fuera de línea */
.status-online {
  color: green;
  font-weight: bold;
}

.status-offline {
  color: gray;
}
</style>
